import { useCallback, useEffect, useRef, useState } from 'react';
import API from 'api/api';
import { translateApiError } from 'i18n/translateApiError';

export function useGetPendingPartners() {
  const [pendingPartners, setPendingPartners] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const mountedRef = useRef(true);

  useEffect(() => {
    return () => {
      mountedRef.current = false;
    };
  }, []);

  const fetchPartners = useCallback(async (signal) => {
    if (mountedRef.current) {
      setLoading(true);
      setError(null);
    }

    try {
      const res = await API.get('/users/admin/partners', {
        signal,
      });

      if (!mountedRef.current) return;
      setPendingPartners(res?.data?.data || []);
    } catch (err) {
      if (err.name === 'CanceledError' || err.code === 'ERR_CANCELED') return;
      if (!mountedRef.current) return;
      setError(translateApiError(err, 'Failed to fetch partners'));
    } finally {
      if (mountedRef.current) setLoading(false);
    }
  }, []);

  useEffect(() => {
    const controller = new AbortController();
    fetchPartners(controller.signal);
    return () => controller.abort();
  }, [fetchPartners]);

  const refetch = useCallback(() => {
    const controller = new AbortController();
    fetchPartners(controller.signal);
    return () => controller.abort();
  }, [fetchPartners]);

  return { pendingPartners, loading, error, refetch };
}
